import clsx from "clsx";
import { Info } from "@/icons";
import { ActionIconText } from "../ActionIconText";
import "./NotificationsSettingsHeader.scss";

type TableHeaderProps = {
  className?: string;
  showEmail?: boolean;
  showSms?: boolean;
};

export const notificationsSettingsHeaderId = (columnKey: string) =>
  `notifications-settings-header-${columnKey}`;

export const NotificationsSettingsHeader = ({
  className,
  showEmail = false,
  showSms = false,
  ...props
}: TableHeaderProps) => {
  const allColumns = [
    {
      label: "Categoria notifica",
      noIcon: true,
      isFlex: true,
      key: "category",
      alwaysVisible: true,
    },
    {
      label: "SMS",
      fixedWidth: true,
      key: "sms",
      visible: showSms,
      popupInfo: {
        title: "SMS",
        description: "SMS come metodo di notifica",
        isOpen: false,
        onClickCloseBtn: () => {},
        ariaLabel: "Informazioni SMS",
      },
    },
    {
      label: "Email",
      fixedWidth: true,
      key: "email",
      visible: showEmail,
      popupInfo: {
        title: "Email",
        description: "Email come metodo di notifica",
        isOpen: false,
        onClickCloseBtn: () => {},
        ariaLabel: "Informazioni Email",
      },
    },
  ];

  const visibleColumns = allColumns.filter(
    (column) => column.alwaysVisible || column.visible,
  );

  return (
    <div>
      <div className={clsx(className)} {...props}>
        <table className="w-full flex" role="table">
          <thead>
            <tr className="w-full flex">
              {visibleColumns.map((column, index) => {
                const headerId = notificationsSettingsHeaderId(column.key);
                return (
                  <th
                    key={headerId}
                    id={headerId}
                    scope="col"
                    aria-colindex={index + 1}
                    data-column-key={column.key}
                    className={clsx(
                      "table-header-divider-cell w-full",
                      column.isFlex ? "flex-1" : "flex-none",
                    )}
                  >
                    <div
                      className={clsx(
                        "table__cell--header--content",
                        column.fixedWidth ? "table-header-fixed-width " : "",
                      )}
                    >
                      <div>
                        <ActionIconText
                          classNameText={"text-grey-black"}
                          noIcon={column.noIcon}
                          icon={<Info />}
                          textLabel={column.label}
                          iconPosition={"right"}
                          popupInfo={column.popupInfo}
                          positionPopUp={
                            visibleColumns.length === index + 1
                              ? "left"
                              : "right"
                          }
                        />
                      </div>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr className="sr-only">
              {visibleColumns.map((column, index) => {
                const headerId = notificationsSettingsHeaderId(column.key);
                return (
                  <td
                    key={`${headerId}-data`}
                    headers={headerId}
                    aria-colindex={index + 1}
                  >
                    {/* Empty data cell for accessibility */}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
      <div className={"table-header-divider"} />
    </div>
  );
};

export default NotificationsSettingsHeader;



